import { IEngagementContext, TNotificationOrigin } from '~/domain/OfficeNotification';
import PosthogService from '~/services/posthog/PosthogService';

export interface IOfficeNotificationOfferExpirationWarningPayload {
  origin: TNotificationOrigin;
  /** Every action-needed shift currently in view ("all that apply"). */
  shiftIds: string[];
  engagement: IEngagementContext;
}

/**
 * Fires when an office lands on the Action Needed shift list from an
 * "offer expiration warning" email CTA.
 * Event: dental_portal:office_notification:offer_expiration_warning
 */
export function fireOfficeNotificationOfferExpirationWarning(
  payload: IOfficeNotificationOfferExpirationWarningPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:office_notification:offer_expiration_warning',
    {
      origin: payload.origin,
      shift_ids: payload.shiftIds,
      ...payload.engagement,
    },
  );
}
